import { ArrowRight, Ruler } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageProvider";
import { BODY_SCAN_PROVIDER_ENABLED } from "@/lib/bodyscan/provider";

interface MirrorBodyScanHandoffCardProps {
  onOpen: () => void;
}

export default function MirrorBodyScanHandoffCard({ onOpen }: MirrorBodyScanHandoffCardProps) {
  const { t } = useLanguage();
  const isMock = import.meta.env.VITE_BODY_SCAN_PROVIDER !== "3dlook";
  return (
    <div className="w-full rounded-2xl border border-primary/20 bg-primary/[0.06] p-3">
      <div className="flex items-center gap-2 text-primary">
        <Ruler size={15} aria-hidden="true" />
        <p className="text-[12px] font-display font-semibold">{t("bodyHealth.scanHandoffTitle")}</p>
      </div>
      <p className="mt-2 text-[12px] text-foreground/70 leading-snug">
        {t(BODY_SCAN_PROVIDER_ENABLED ? "bodyHealth.scanHandoffDescription" : "bodyHealth.scanUnavailable")}
      </p>
      {BODY_SCAN_PROVIDER_ENABLED && isMock && (
        <p className="mt-2 text-[11px] text-foreground/60">{t("bodyHealth.scanMockNotice")}</p>
      )}
      <button type="button" onClick={() => { if (BODY_SCAN_PROVIDER_ENABLED) onOpen(); }}
        disabled={!BODY_SCAN_PROVIDER_ENABLED}
        className="mt-3 inline-flex items-center gap-2 rounded-xl border border-primary/25 px-3 py-2 text-[12px] text-primary disabled:opacity-40">
        {t("bodyHealth.openBodyMeasurements")}<ArrowRight size={13} aria-hidden="true" />
      </button>
    </div>
  );
}
